import React from 'react';
import { Content, Page, Header } from '@backstage/core-components';
import { Grid, makeStyles } from '@material-ui/core';
import {
  HomePageCompanyLogo,
  HomePageStarredEntities,
  HomePageRecentlyVisited,
  HomePageRandomJoke,
  HomePageToolkit,
  TemplateBackstageLogoIcon,
} from '@backstage/plugin-home';

const useStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  grid: {
    gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
    gridGap: theme.spacing(2),
  },
}));

export const HomePage = () => {
  const classes = useStyles();

  return (
    <Page themeId="home">
      <Header title="Internal Developer Platform" subtitle="Accelerating software delivery with modern developer experience" />
      <Content>
        <Grid container spacing={3} className={classes.container}>
          {/* 公司Logo */}
          <Grid item xs={12} md={6}>
            <HomePageCompanyLogo
              logo={<TemplateBackstageLogoIcon />}
            />
          </Grid>

          {/* 工具箱 */}
          <Grid item xs={12} md={6}>
            <HomePageToolkit
              tools={[
                {
                  url: '/catalog',
                  label: 'Service Catalog',
                  icon: 'kind:component',
                },
                {
                  url: '/docs',
                  label: 'Tech Docs',
                  icon: 'docs',
                },
                {
                  url: '/create',
                  label: 'Create Component',
                  icon: 'scaffolder',
                },
                // {
                //   url: '/tech-radar',
                //   label: 'Tech Radar',
                //   icon: 'radar',
                // },
              ]}
            />
          </Grid>

          {/* 收藏的实体 */}
          <Grid item xs={12} md={6}>
            <HomePageStarredEntities />
          </Grid>

          {/* 最近访问 */}
          <Grid item xs={12} md={6}>
            <HomePageRecentlyVisited />
          </Grid>

          {/* 随机笑话（可选，用于轻松氛围） */}
          <Grid item xs={12}>
            <HomePageRandomJoke />
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
